<a
  class="group flex h-full cursor-pointer flex-col"
  [routerLink]="getRouterLink()"
>
  <div class="flex-grow">
    <img
      class="w-full transform object-cover transition-transform duration-300 group-hover:scale-105"
      [src]="imageUrl()"
      [alt]="'magazines.images.cover' | translate"
      width="150"
      height="200"
    />
  </div>

  <div class="mt-4 flex h-full flex-col justify-between">
    <div class="flex">
      <h6
        class="mr-2 overflow-hidden font-medium break-words text-neutral-800 lg:text-xl"
      >
        {{ title() }}
      </h6>
      <img
        class="ml-auto h-6 w-6 rotate-180 transform transition-transform duration-300 group-hover:translate-x-2"
        src="/assets/icons/arrow_left_icon.svg"
        alt=""
      />
    </div>
    <div
      class="mt-4 text-sm text-neutral-500 transition-colors duration-300 group-hover:text-neutral-800 lg:text-base"
    >
      @if (year && edition) {
        <span>
          {{ 'magazines.text.readNow' | translate: { year, edition } }}
        </span>
      }
      @if (publicationDate) {
        <span>
          {{
            'magazines.text.publishedAt'
              | translate: { date: (publicationDate | localizedDate) }
          }}
        </span>
      }
    </div>
  </div>
</a>
